/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccPatientAddress } from './PccPatientAddress';
import {
    PccPatientAddressFromJSON,
    PccPatientAddressFromJSONTyped,
    PccPatientAddressToJSON,
} from './PccPatientAddress';

/**
 * 
 * @export
 * @interface PatchPccDemographicsRequest
 */
export interface PatchPccDemographicsRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    home_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    cell_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    marital_status?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    race?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    prefix?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPccDemographicsRequest
     */
    suffix?: string;
    /**
     * 
     * @type {PccPatientAddress}
     * @memberof PatchPccDemographicsRequest
     */
    previous_address?: PccPatientAddress;
}

/**
 * Check if a given object implements the PatchPccDemographicsRequest interface.
 */
export function instanceOfPatchPccDemographicsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchPccDemographicsRequestFromJSON(json: any): PatchPccDemographicsRequest {
    return PatchPccDemographicsRequestFromJSONTyped(json, false);
}

export function PatchPccDemographicsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchPccDemographicsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'home_phone': !exists(json, 'home_phone') ? undefined : json['home_phone'],
        'cell_phone': !exists(json, 'cell_phone') ? undefined : json['cell_phone'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'marital_status': !exists(json, 'marital_status') ? undefined : json['marital_status'],
        'race': !exists(json, 'race') ? undefined : json['race'],
        'prefix': !exists(json, 'prefix') ? undefined : json['prefix'],
        'suffix': !exists(json, 'suffix') ? undefined : json['suffix'],
        'previous_address': !exists(json, 'previous_address') ? undefined : PccPatientAddressFromJSON(json['previous_address']),
    };
}

export function PatchPccDemographicsRequestToJSON(value?: PatchPccDemographicsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'home_phone': value.home_phone,
        'cell_phone': value.cell_phone,
        'language': value.language,
        'marital_status': value.marital_status,
        'race': value.race,
        'prefix': value.prefix,
        'suffix': value.suffix,
        'previous_address': PccPatientAddressToJSON(value.previous_address),
    };
}

